"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const PreviewPill_1 = __importStar(require("../PreviewPill"));
const utils_1 = require("../../utils");
const utils_2 = require("./utils");
function PrettySelectButtonLabel(props) {
    const value = utils_2.getOptionValue(props.item);
    if (lodash_1.startsWith(value, '{{') && lodash_1.endsWith(value, '}}')) {
        const tag = utils_1.removeFieldMappingBraces(value);
        const previewPillProps = PreviewPill_1.getPreviewPillProps(props.choiceGroups, tag);
        return react_1.default.createElement(PreviewPill_1.default, Object.assign({}, previewPillProps));
    }
    return utils_2.getOptionLabel(props.item);
}
exports.default = PrettySelectButtonLabel;
